export default __webpack_public_path__ + "static/clutch-2021-a00787fd701553972978305cc4aaa457.png";